module.exports = require("./fr-CD");